import { LumosMemberOverviewPage } from '@omnia/ui/src/lib/lumos-plus'
import { LumosPlusExtension } from '@omnia/ui/src/lib/lumos-plus/extendability/lumos-plus-extendability-context'
import { getBemClassBuilder } from '@omnia/ui/src/lib/lumos-plus/utils/get-bem-class-builder'
import { Button, ButtonColor, ButtonSize, ModalMode } from '@vista-digital/occ-ui'
import { Modal } from '@vista-digital/occ-ui/src/lib/subcomponents/modal/modal'
import type { FC } from 'react'
import { MemberBalanceList } from '../../balance/MemberBalanceList'

const ComponentName = 'BalanceModal'
const b = getBemClassBuilder(ComponentName)

interface BalanceModalProps {
    onClose: VoidFunction
    onContinue: VoidFunction
}

export const BalanceModal: FC<BalanceModalProps> = ({ onClose, onContinue }) => {
    return (
        <Modal className={b.block()} show onClose={onClose} mode={ModalMode.Overlay}>
            <LumosPlusExtension memberBalance={() => <MemberBalanceList />}>
                <LumosMemberOverviewPage />
                <Button
                    className={b.element('continue-button')}
                    size={ButtonSize.Medium}
                    label={'Continuar Compra'}
                    color={ButtonColor.Secondary}
                    onClick={onContinue}
                />
            </LumosPlusExtension>
        </Modal>
    )
}

BalanceModal.displayName = ComponentName
